import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement
} from './common';
import {
    CALL_API
} from 'redux-api-middleware';
const apiUrl = '/api/users';

export function submitUser(values) {
    return submitElement(apiUrl, values, types.SUBMIT_USER);
}
export function fetchUser(itemId) {
    return fetchElement(apiUrl, itemId, types.ADMIN_LOAD_USER);
}

export function loadUsers(page = 0, size = 10) {
    return fetchElementsPaginated(apiUrl, page, size, types.ADMIN_LOAD_USERS);
}

export function login(values) {
    return submitElement('/api/auth/login', values, types.LOGIN_USER);
}
export function logout() {
    return {
        [CALL_API]: {
            endpoint: '/api/auth/logout',
            method: 'POST',
            types: types.LOGOUT.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/users.js